<script setup>
const ServicesLanguagesContent = defineAsyncComponent(() => import('~/components/molecules/ServicesLanguagesContent.vue'));
definePageMeta({
  layout: "services-layout",
});
</script>

<template>
    <ServicesLanguagesContent />
</template>